import API from "../api/axios";

// ─── Get All Users ───
export const getAllUsers = () => {
   return API.get("/users");
};

// ─── Register User ───
export const registerUser = (data) => {
   return API.post("/register", data);
};

// ─── Update User ───
export const updateUser = (id, data) => {
   return API.put(`/users/${id}`, data);
};

// ─── Delete User ───
export const deleteUser = (id) => {
   return API.delete(`/users/${id}`);
};

// ─── Approve User ───
export const approveUser = (id) => {
   return API.put(`/users/approve/${id}`);
};

// ─── Toggle User Status ───
export const toggleUserStatus = (id, data) => {
   return API.put(`/users/status/${id}`, data);
};